var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcfStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 15V55.0008M75 40.0008L60 55.0008L45 40.0008",
    stroke: "#719A5D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0008 19.9992H33.6C32.5094 19.9412 31.4299 20.2424 30.527 20.8567C29.624 21.471 28.9474 22.3644 28.6008 23.4L15 64.9992V100.001C15 101.327 15.5267 102.598 16.4642 103.536C17.4018 104.473 18.6733 105 19.9992 105H100.001C101.327 105 102.598 104.473 103.536 103.536C104.473 102.598 105 101.327 105 100.001V64.9992L91.152 23.4C90.8177 22.4058 90.1786 21.5421 89.3256 20.9317C88.4726 20.3212 87.4489 19.995 86.4 19.9992H79.9992M105 64.9992H79.9992C79.9992 70.3034 77.8921 75.3902 74.1416 79.1408C70.391 82.8914 65.3041 84.9984 60 84.9984C54.6959 84.9984 49.609 82.8914 45.8584 79.1408C42.1079 75.3902 40.0008 70.3034 40.0008 64.9992H15",
    stroke: "#0D5F4F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcfStep5);
export default __webpack_public_path__ + "static/media/PCFStep5.6aef8fc4a8aed926cbbdc585b8f9a04a.svg";
export { ForwardRef as ReactComponent };